import styled from "styled-components";

const BodyWrapper = styled.div`
  background-color: white;
  width: fit-content;
  border-radius: 13px;
  padding: 5px 10px;
  display: flex;
  gap: 10px;
  align-items: center;

  .filterName {
    color: #004576;
    font-weight: 600;
    font-size: 12px;
    padding-right: 10px;
    border-right: 1px solid rgba(0, 0, 0, 0.15);
  }

  .value {
    color: #004576;
    font-weight: 600;
    font-size: 12px;
    max-width: 200px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .button {
    border: none;
    background-color: #004576;
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 12px;
    border-radius: 20px;
    color: white;
    cursor: pointer;
  }
`;
const FilterChips = ({
  filterName,
  value,
  lowerLimit,
  upperLimit,
  onCrossClick,
}) => {
  return (
    <BodyWrapper>
      <div className="filterName">{filterName}</div>
      <div className="value">
        {Array.isArray(value) && value?.length > 0 ? (
          value.map((data, index) => (
            <span>
              {data}
              {index !== value?.length - 1 && ","}{" "}
            </span>
          ))
        ) : (
          <>
            <span>
              {lowerLimit} - {upperLimit}
            </span>
          </>
        )}
      </div>
      <button className="button" onClick={() => onCrossClick(filterName)}>
        X
      </button>
    </BodyWrapper>
  );
};

export default FilterChips;
